// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsSection_container__36YMG"};